import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../../app/hooks';

import {
    Box,
    Typography,
    TextField,
    Select,
    MenuItem,
    SelectChangeEvent,
    Button,
} from "@mui/material";
import ConfirmDialog from '../../common/ConfirmDialog';
import { setReceptionBook } from '../../../features/receptionBookSlice';
import { hasScroll } from "../../common/Scroll";
import { useUtilityContext } from '../../../utility-provider';
import { useUserContext } from '../../../user-provider';
import { encryptQueryParam, decryptQueryParam } from '../../../utility/util';
import { userLogging } from '../../../utility/firestore';
import { LOCAL_CONSTANT } from '../../common/Const';

export interface resultProps {
    props:{
    }
}

const TrafficVolume:React.FC<resultProps> = ({props}) => {

    const dispatch = useAppDispatch();
    const utilityCtx = useUtilityContext();
    const user = useUserContext();
    const navigate = useNavigate();

    //URLパラメータ
    const [planAreaId, setPlanAreaId] = React.useState("");
    const [referrer, setReferrer] = React.useState<any>("");

    const [measurementTime, setMeasurementTime] = React.useState("")
    const [measurementType, setMeasurementType] = React.useState("1")

    // ダイアログ開閉フラグ
    const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);

    const objReceptionBook = useAppSelector((state) => state.receptionBook.select);
    const rviewStoreCode = useAppSelector((state) => state.rviewStoreData.storeCode);


    React.useEffect(() => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        hasScroll();
        //暗号化されたクエリパラメータを復号化
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            if (res[0] && res[0].trim() !== '') {
                setPlanAreaId(res[0]);
                setReferrer(res[1]);
                dispatch(setReceptionBook({
                    ...objReceptionBook,
                    plan_area_id: res[0]
                }));

                // 画面表示 userLogging
                if (user.userData) {
                    const decryptedUrl = window.location.pathname + `?planAreaId=${res[0]}&referrer=${res[1]}`;
                    const encryptedUrl = window.location.pathname + window.location.search;
                    userLogging(
                        LOCAL_CONSTANT.FUNCTION_NAME.TRAFFIC_VOLUME_DISPLAY,
                        {
                            decrypted_url: decryptedUrl,
                            encrypted_url: encryptedUrl
                        },
                        user
                    );
                }
            } else {
                // planAreaIdが存在しない場合はダイアログを表示
                setErrorDialogOpen(true);
            }
        }).catch((e:any) => {
            console.log(e);
            // 復号化エラーの場合もダイアログを表示
            setErrorDialogOpen(true);
        }).finally(() => {
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    }, []);

    const handleSelectChange = (e: SelectChangeEvent<string>) => {
        setMeasurementType(e.target.value)
    };

    const REGEX_NUMBER = /^[0-9]*$/g;
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (!e.target.value.match(REGEX_NUMBER)) {
            return
        }
        setMeasurementTime(e.target.value)
    }

    const checkDisabled = () => {
        if (measurementTime === '') {
            return true
        }

        if (isNaN(Number(measurementTime))) {
            return true
        }

        return false
    }

    const clickHandle = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        const param = `planAreaId=${planAreaId}&referrer=${referrer}&measurementTime=${measurementTime}&measurementType=${measurementType}`;
        // URLパラメータ暗号化
        encryptQueryParam(param).then((res) => {
            const url = "/TrafficVolume/regist?" + res;
            navigate(url);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    }

    const clickBack = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        let param = "";
        if(referrer === "") {
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            return navigate("/");
        } else if(referrer === "rview") {
            param = `planAreaId=${planAreaId}`;
        } else if(referrer === "rview-store") {
            param = `storecode=${rviewStoreCode}`;
        }
        // URLパラメータ暗号化
        encryptQueryParam(param).then((res) => {
            let url = "";
            if(referrer === "rview") {
                url = `/Planareamenu?${res}`;
            } else if(referrer === "rview-store") {
                url = `/StoreMenu?${res}`;
            }
            navigate(url);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    }
    
    return (
        <Box style={{ width: "100%", margin: 0, padding: 0, position: 'relative' }}>
            <Box sx={{margin: '0 10px'}}>
                <Button
                    variant="outlined"
                    size="small"
                    sx={{margin: '4px', minWidth: '30px', padding: '10px 0',
                    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
                    }}
                    onClick={clickBack}
                >≪</Button>
            </Box>
            <Box sx={{height: '30px', margin: '20px'}}>
                <Typography>{objReceptionBook.plan_area_id}</Typography>
            </Box>
            <Box sx={{height: '400px'}}>
                <Box sx={{margin: '20px'}}>
                    <Typography>測定時間（分）</Typography>
                    <TextField
                        type="number"
                        onChange={handleInputChange}
                        value={measurementTime}
                    ></TextField>
                </Box>
                <Box sx={{margin: '20px'}}>
                    <Typography>測定種別</Typography>
                    <Select
                        onChange={handleSelectChange}
                        value={measurementType}
                        ><MenuItem value="1">車のみ</MenuItem>
                        <MenuItem value="2">人のみ</MenuItem>
                        <MenuItem value="3">車＋人（5m内）</MenuItem>
                        <MenuItem value="0">車＋人（5m内外）</MenuItem>
                    </Select>
                </Box>
            </Box>
            <Box sx={{ width: '100%', height: '60px', position: 'fixed', left: 0, bottom: 0, margin: '10px'}}>
                <Button variant="contained" color="success" size="small"
                    disabled={checkDisabled()}
                    sx={{width: '95%', height: '55px'}}
                    onClick={clickHandle}
                >カウンター</Button>
            </Box>
            <ConfirmDialog props={{
                open: errorDialogOpen,
                handleModal: setErrorDialogOpen,
                onCancel: () => {},
                onExecution: () => {},
                onCancelRegist: () => {},
                mode: "",
                body: LOCAL_CONSTANT.ERROR_MESSAGE.PLAN_AREA_ID_NOT_FOUND,
                confirmCancel: "",
                confirmOk: "",
                confirmCancelRegist: "",
            }} />
        </Box>
    );
        
}


export default TrafficVolume;
